import * as React from 'react';

import classNames from 'classnames';
import _ from 'underscore';

import {SearchIcon, CloseIcon as Clear} from '../icon';
import {TextField} from '../textfield/textfield';

import styles from './search-bar.module.css';

const DEFAULT_HEIGHT = '35px';
const ACTIVE_BORDER_COLOR = '#1ba0e1'; // This is `var(--blue)`

type Props = {
    onChange: (arg1: string) => any;
    value: string;
    placeholder: string;
    isClearable?: boolean;
    autoFocus?: boolean;
    onBlur?: () => any;
    onFocus?: () => any;
    searchBarRef?: (arg1?: HTMLInputElement | null | undefined) => any;
    hasBorder?: boolean;
    styleOptions?: {
        height?: string | number;
        borderColor?: string;
    };
    // Renders with less padding
    isSmall?: boolean;
    // This is the accessibility label string
    hiddenLabel?: string;
    noSearchIcon?: boolean;
};

type State = {
    isFocused: boolean;
};

export class SearchBar extends React.Component<Props, State> {
    inputRef: HTMLInputElement | null | undefined;

    static defaultProps = {
        placeholder: 'Search…',
        value: '',
    };

    constructor() {
        // @ts-expect-error
        super();
        this.state = {
            isFocused: false,
        };
    }

    componentDidMount() {
        if (this.props.autoFocus) {
            _.defer(this.focusSearchBar);
        }
    }

    render() {
        const {styleOptions, value, isClearable} = this.props;

        const containerStyle = {
            height: styleOptions ? styleOptions.height : DEFAULT_HEIGHT,
            borderColor:
                this.state.isFocused && this.props.hasBorder ? ACTIVE_BORDER_COLOR : undefined,
        } as const;

        const searchBarStyleNames = classNames(styles.input, {
            [styles['input--small']]: this.props.isSmall,
            [styles['input--no-icon']]: this.props.noSearchIcon,
        });

        return (
            <div
                style={containerStyle}
                className={this.props.hasBorder ? styles.bordered : styles['no-border']}
            >
                {!this.props.noSearchIcon && (
                    <div
                        className={
                            this.props.isSmall
                                ? styles['search-container--small']
                                : styles['search-container']
                        }
                    >
                        <SearchIcon className={styles['search-icon']} />
                    </div>
                )}
                <div className={searchBarStyleNames}>
                    {this.props.hiddenLabel ? (
                        <label htmlFor='search' className='display-none'>
                            {this.props.hiddenLabel}
                        </label>
                    ) : undefined}
                    <TextField
                        id='search'
                        value={value}
                        placeholder={this.props.placeholder}
                        textFieldRef={this.handleRefAssignment}
                        noBorder={true}
                        onFocus={this.handleFocus}
                        // @ts-expect-error
                        onBlur={this.handleBlur}
                        onChange={this.handleChange}
                    />
                </div>
                {value && isClearable ? (
                    <button
                        onClick={this.handleClear}
                        className={this.props.isSmall ? styles['clear--small'] : styles.clear}
                    >
                        <Clear
                            size={10}
                            className={this.props.isSmall ? styles['clear--small'] : styles.clear}
                        />
                    </button>
                ) : undefined}
            </div>
        );
    }

    handleChange = (value: string) => {
        this.props.onChange(value);
    };

    handleFocus = () => {
        this.setState({isFocused: true});
        if (this.props.onFocus) {
            this.props.onFocus();
        }
    };

    handleBlur = () => {
        this.setState({isFocused: false});
        if (this.props.onBlur) {
            this.props.onBlur();
        }
    };

    handleClear = () => {
        this.props.onChange('');
    };

    focusSearchBar = () => {
        if (this.inputRef) {
            this.inputRef.focus();
        }
    };

    handleRefAssignment = (node?: HTMLInputElement | null) => {
        this.inputRef = node;

        if (this.props.searchBarRef) {
            this.props.searchBarRef(node);
        }
    };
}
